import { render, staticRenderFns } from "./into-abroadlogistics-check.vue?vue&type=template&id=579a539e&"
import script from "./into-abroadlogistics-check.vue?vue&type=script&lang=ts&"
export * from "./into-abroadlogistics-check.vue?vue&type=script&lang=ts&"
import style0 from "./into-abroadlogistics-check.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports